import React from "react";
import {
  CButton,
  CCol,
  CModal,
  CFormGroup,
  CModalBody,
  CModalFooter,
} from "@coreui/react";
import loadImage from "blueimp-load-image";
import { useSelector } from "react-redux";

const ShowImgPop = (props) => {
  if (!HTMLCanvasElement.prototype.toBlob) {
    Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
      value: function(callback, type, quality) {
        var canvas = this;
        setTimeout(function() {
  
          var binStr = atob(canvas.toDataURL(type, quality).split(',')[1]),
            len = binStr.length,
            arr = new Uint8Array(len);
  
          for (var i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
          }
  
          callback(new Blob([arr], {
            type: type || 'image/png'
          }));
  
        });
      }
    });
  }

  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const fileList = useSelector((state) => state.sbmsDoc.sbmsDocFiles);
  const docNo = Number(props.docNo);
  const [imgList, setImgList] = React.useState([]);

  React.useEffect(() => {
    const fileInfoList = [];
    const temp = fileList.filter(
      (file) => Number(file.docNo) === Number(docNo)
    );
    let i = 0;

    temp[0].fileInfo.forEach((item) => {
      if (item.seqNo !== "") {
        fileInfoList.push({
          realFileNm: item.realFileNm,
          name: item.fileNm,
          midPath: item.midPath,
        });
      } else {
        const previewContainer = document.getElementById("previewBody");
        const preview = document.createElement("img");
        const textArea = document.createElement("div");
        const text = document.createTextNode(item.fileNm);
        let file = temp[0].file[i];
        let fileType = file.type;
        let reader = new FileReader();

        textArea.setAttribute("class", "text-left col-12");
        textArea.setAttribute("style", "padding: 10px;");
        preview.setAttribute("width", "100%");
        preview.setAttribute("alt", item.fileNm);
        textArea.appendChild(text);
        previewContainer.appendChild(textArea);
        previewContainer.appendChild(preview);

        if(fileType === "image/jpeg") {
          loadImage(file, function(img, data) {
            if (data.imageHead && data.exif) {
              loadImage.writeExifData(data.imageHead, data, 'Orientation', 1)
              img.toBlob(function (blob) {
                loadImage.replaceHead(blob, data.imageHead, function (newBlob) {
                  reader.onload = () => (preview.src = reader.result);
                  reader.readAsDataURL(newBlob);
                })
              }, 'image/jpeg')
            }
          }, { meta: true, orientation: true, canvas: true, maxWidth: 800 })
        } else {
          reader.onload = () => (preview.src = reader.result);
          reader.readAsDataURL(file);
        }
        i++;
      }
    });

    setImgList(fileInfoList);
  }, []);

  return (
    <>
      <CModal
        show={true}
        // size="lg"
        closeOnBackdrop={false}
        onClosed={() => {
          props.onClose();
        }}
      >
        <CModalBody className="apoModalBody">
          {imgList.map((imgData, index) => {
            return (
              <React.Fragment key={index}>
                <CFormGroup row>
                  <CCol xs="12" className="text-left">
                    <h6>
                      <b>{imgData.name}</b>
                    </h6>
                  </CCol>
                  <img
                    src={imgData.midPath == null ? `${appUrl}cust/request/getImages/sbmsDoc?${imgData.realFileNm}` : `${appUrl}cust/request/getImages/fileDoc?${imgData.midPath}sbmsDoc/${imgData.realFileNm}`}
                    alt={`img${index}`}
                    width="100%"
                  />
                </CFormGroup>
              </React.Fragment>
            );
          })}
          <CFormGroup row id="previewBody"></CFormGroup>
        </CModalBody>
        <CModalFooter>
          <div className="layout-footer">
            <button className="btn-footer" type="button" 
            onClick={() => {
              props.onClose();
            }}>
              닫기
            </button>
          </div>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default ShowImgPop;
